import { getThemeFontFamilySpec, getThemeFontKey, DEFAULT_FONT_KEY } from '../components/VoiceWidget/themes';

/**
 * Подгрузка брендового шрифта тенанта по требованию (#1330).
 *
 * `index.html` витрины грузит ТОЛЬКО наш Source Sans 3. Шрифты тенантов —
 * Roboto у Andy's, Raleway у OMODA/JAECOO — приезжают лишь тогда, когда
 * рисуется их поверхность. Раньше все три висели в `<head>` и тянулись на
 * каждой странице; Raleway при этом нужен ровно на одном экране Autodis, а на
 * нашей демо-организации new-model машин нет вообще, то есть он не
 * использовался никогда.
 *
 * Для встраивания у дилера этот путь не нужен: там шрифт инжектит
 * `bootstrap.jsx` прямо в Shadow DOM, тоже из темы.
 *
 * Идемпотентно: повторный вызов с тем же стилем ничего не делает.
 */
export const ensureTenantFont = (styleName) => {
  if (typeof document === 'undefined') return;

  const key = getThemeFontKey(styleName);
  // Наш шрифт уже в <head> статикой — второй раз не просим.
  if (key === DEFAULT_FONT_KEY) return;

  const marker = `tenant-font-${key}`;
  if (document.head.querySelector(`link[data-sg-font="${marker}"]`)) return;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${getThemeFontFamilySpec(styleName)}&display=swap`;
  link.setAttribute('data-sg-font', marker);
  document.head.appendChild(link);
};

export default ensureTenantFont;
